import { apiClientPackages } from 'tsx/constants/api';
import { get } from 'tsx/libs/genericAction';
import { createThunks, Params } from 'tsx/libs/reduxUtils';

import { typePrefix as prefix } from '~main/actions/clients';

export const typePrefix = `${prefix}-packages`;

const config = [
  {
    actionType: 'getAll',
    apiPath: apiClientPackages,
    method: get,
    actionParams: { limit: 0 },
  },
  {
    actionType: 'getOne',
    apiPath: (params: Params) => `${apiClientPackages}/${params.id}`,
    method: get,
  },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
